import { api } from "@/api";
import { AxiosResponse } from "axios";
import { PayloadWhitePaperItems, PayloadSuccessCase } from "../types";

class API {
  static getWhitePapers(
    payload: PayloadWhitePaperItems
  ): Promise<AxiosResponse> {
    return api.get("/white-paper/list", { params: payload });
  }
  static getSuccessCase(payload: PayloadSuccessCase): Promise<AxiosResponse> {
    return api.get("/success-case/list", { params: payload });
  }
}

export default API;
